/** 點數狀態 */
export enum PointStatus {
  /** 發放 */
  ISSUE = '0',
  /** 兌換 */
  EXCHANGE = '1',
  /** 歸還 */
  RETURN = '2',
  /** 過期 */
  EXPIRED = '3'
}
